import React, {FunctionComponent} from "react";
import WizardStep from "../WizardStep";
import statusPhoto from "../../../images/Progress/progress_foto.svg";
import GradientButton from "../../../commonComponents/GradientButton";
import {Box, makeStyles} from "@material-ui/core";
import UnderlinedTextButton from "../../../commonComponents/UnderlinedTextButton";
import {Step} from "../../WizardMap";
import useImage from "../../state/hooks/imageHook";
import {NavigationProps} from "../../slideRouter/navigationHook";

const useStyles = makeStyles(theme => ({
    imageContainer: {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        flexDirection: "column",
        width: "90%"
    },
    image: {
        height: 250,
        marginTop: 20,
        marginBottom: 20,
        [theme.breakpoints.down("xs")]: {
            marginTop: 10,
            marginBottom: 10,
            height: 200
        }
    }
}));

const StepPhoto: FunctionComponent<NavigationProps> = ({gotoPrevSlide, gotoNextSlide}) => {

    const classes = useStyles();

    // const theme = useTheme();

    const {image, HiddenInputComponent, openNativeImageModal, removeImage} = useImage();

    return (
        <WizardStep
            title={"Bitte laden Sie ein Foto hoch"}
            icon={statusPhoto}
            backButton={true}
            nextButton={true}
            onBackClick={gotoPrevSlide}
            onNextClick={() => gotoNextSlide(Step.ADD_DISPOSAL)}
        >
            <HiddenInputComponent/>
            {!image.url && <GradientButton onClick={openNativeImageModal} width={200} text="Foto hochladen"/>}
            {image.url &&
            <Box className={classes.imageContainer}>
                <img className={classes.image} src={image.url} alt={""}/>
                <UnderlinedTextButton text={"Bild löschen"} onClick={() => removeImage()}/>
            </Box>}

            {/*<Box paddingTop={4}>*/}
            {/*    <Text value={error ?  error : "max 4 mb"} size={error ? 12 : 11} color={error ? theme.palette.text.hint : undefined}/>*/}
            {/*</Box>*/}
        </WizardStep>
    );
};


export default StepPhoto;
